export enum EUserChallengeStatus {
  NEW = "NEW",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  WAITING_FOR_VALIDATION = "WAITING_FOR_VALIDATION",
  NEED_REVISION = "NEED_REVISION",
}
